import React, { useState, useEffect } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';
import ClipLoader from "react-spinners/ClipLoader";

import { makeStyles } from "@material-ui/core/styles";
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import api from '../../services/api';

const styles = {
  iconInput: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2
  },

  iconInputLogin: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2
  },

  iconInputLoginEye: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    cursor: 'pointer'
  },

  margin: {
    height: 50
  },

  cardTitleWhite: {
    fontSize: '31px',
    color: "#1989FF",
    textAlign: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px'
  },
};

const useStyles = makeStyles(styles);

export default function RecuperarSenhaVerificacao() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useToasts();
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [codigoVerificacao, setCodigoVerificacao] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!location.state?.email || !location.state?.token) {
      history.push("/");
    } else {
      setEmail(location.state.email);
      setToken(location.state.token);
    }
  }, [history, location.state?.email, location.state?.token]);

  const handleSignIn = async () => {
    if (!codigoVerificacao) {
      addToast("Por favor, informe o Código de Verificação recebido no email!", { appearance: 'error' });
      return;
    }
    try {
      setLoading(true);
      let recupera = await api.confirmaCodigoVerificacao(token, codigoVerificacao);
      if (recupera.success) {
        history.push("/recuperarsenha/confirmar", { token, codigoVerificacao });
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      addToast(err.message, { appearance: 'error' });
    }
  };

  return (
    <div style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
      <GridContainer style={{ justifyContent: 'center', alignItems: 'center', height: '100%', zIndex: 1 }} >
        <GridItem>
          <Card style={{
            backgroundColor: '#f8f9fd',
            borderRadius: 25,
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            borderColor: '#C8C8C8',
            height: '380px',
            width: '380px',
            boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
          }}>
            <CardHeader style={{ height: '30px', marginTop: 20 }}>
              <h4 className={classes.cardTitleWhite} style={{
                fontWeight: 400,
                color: '#1989ff',
                fontSize: 19,
                lineHeight: '26px'
              }}>Por favor, digite o código de verificação enviado para o email <b>{email}</b></h4>
            </CardHeader>

            <CardBody style={{ marginTop: 45, padding: 0, textAlign: 'center' }}>
              <GridItem>
                <FormControl xs={12} sm={12} md={12} style={{ marginTop: 70, marginRight: 5, textAlign: 'center' }}>
                  <Input xs={12} sm={12} md={12}
                    style={{
                      width: 200,
                      borderRadius: 8,
                      padding: 0,
                      fontWeight: 'bold',
                      fontSize: 32,
                      textAlign: 'center'
                    }}
                    autoFocus={false}
                    disableUnderline
                    id="codigoVerificacao"
                    placeholder="000000"
                    inputProps={{
                      style: { textAlign: 'center', letterSpacing: '10px !important' },
                      value: codigoVerificacao,
                      type: 'number',
                      onChange: (event) => {
                        setCodigoVerificacao(event.target.value.replaceAll(' ', ''));
                      },
                    }}
                  />
                </FormControl>
              </GridItem>
            </CardBody>

            <CardFooter style={{ justifyContent: 'center', alignItems: 'baseline', height: '100px', display: 'grid', padding: 0 }}>
              <Button style={{ borderRadius: '25px', width: 180 }} onClick={() => handleSignIn()} color="primary" disabled={loading}>Enviar</Button>
              <Link style={{ marginBottom: 5, color: '#1989ff', fontWeight: 500 }} to="/">Voltar</Link>
            </CardFooter>

            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
              <ClipLoader
                size={80}
                color={"#364e6b"}
                loading={loading}
                css={{ border: '8px solid', borderBottomColor: 'transparent' }}
              />
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
